export function HouseIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg viewBox="0 0 12 11" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4.8 10.2h5.4V5.4H12L6 0 0 5.4h1.8v4.8z" fill="currentColor" />
    </svg>
  )
}
